<template>
    <div class="home">
        <b-container fluid v-if="!isLoading">
            <b-row>
                <b-col>
                    <h1>Application History</h1>
                </b-col>
            </b-row>

            <div class="card">
                <div class="card-header">Applicant Information</div>
                <div class="card-body">
                    <Address :value="application.prevAddress" :international="application.international"/>

                    <span style="display:inline-block; margin-bottom:0px;">
                        <label style="margin-bottom:1px;"><strong>Contact Information</strong></label><br/>
                    </span>
                    <div v-for="(contact, index) in application.prevContacts" :key="contact.id">
                        <b-row>
                            <b-col cols="4"><BaseTextOutput label="Preferred Phone" :value="contact.preferredPhone"/></b-col>
                            <b-col cols="4"><BaseTextOutput label="Email Address" :value="contact.emailAddress"/></b-col>
                            <b-col cols="4"><BaseTextOutput label="Date Changed" :value="contact.changeDate"/></b-col>
                        </b-row>
                    </div>

                    <div v-if="!isFinance">
                        <h2 class="mt-4">Attachments</h2>
                        <AttachmentList :value="application.prevAttachments"/>
                    </div>

                </div>
            </div>

            <div class="card" v-if="!isFinance">
                <div class="card-header">Employment Background</div>
                <div class="card-body">
                    <div v-if="application.licenseSubCategory !== 'FULL'">
                        <div v-for="(supervisor, index) in application.prevMnSupervisor" :key="supervisor.id"
                             v-bind:class="{'border-bottom':index !== application.mnSupervisor.length-1, 'mt-3': index !== 0}">
                            <b-row>
                                <b-col cols="6">
                                    <BaseTextOutput label="Supervisor" :value="supervisor.formattedAffirmation"/>
                                </b-col>
                                <b-col cols="6" v-if="application.licenseSubCategory === 'GUEST' || application.subCategory === 'GUEST'">
                                    <BaseTextOutput label="Work Dates" :value="supervisor.workDate.startDate + ' thru ' + supervisor.workDate.endDate"/>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2"><BaseTextOutput label="Received Date" :value="supervisor.receivedDate"/></b-col>
                                <b-col cols="4"><BaseTextOutput label="Establishment Name" :value="supervisor.establishment.supervisedEstName"/></b-col>
                                <b-col cols="6"><BaseTextOutput label="Establishment Address" :value="supervisor.establishment.supervisedEstFullAddress"/></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4"><BaseTextOutput label="Establishment Phone" :value="supervisor.establishment.supervisedEstPhoneNumber"/></b-col>
                                <b-col cols="4"><BaseTextOutput label="Establishment Website" :value="supervisor.establishment.supervisedEstWebsite"/></b-col>
                                <b-col cols="4">
                                    <label style="margin-bottom:1px;"><strong>Establishment Hours</strong></label>
                                    <b-row v-for="hrs in supervisor.establishment.establishmentHours" :key="hrs.id">
                                        <b-col cols="12">
                                            {{hrs.days.map(d => d.description).join(', ') + ': ' + hrs.hours}}
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div v-if="application.licenseSubCategory === 'FULL'">
                        <Employers class="mt-5" :value="application.employers"/>
                    </div>
                </div>
            </div>

             <div class="card" v-if="!isFinance">
                <div class="card-header">Applicant Questionnaire</div>
                <QuestionResponses :value="application.prevQuestionResponses" />
            </div>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Address from '@/components/templates/Address.vue'
import AttachmentList from '@/components/templates/AttachmentList.vue'
import QuestionResponses from '@/components/templates/QuestionResponses.vue'
import Employers from '@/components/templates/Employers'

export default {
    components: {
        Address,
        AttachmentList,
        QuestionResponses,
        Employers,
    },
    data: () => ({
        application: {},
        isLoading: true
    }),
    mounted() {
        this.loadApplication()
    },
    computed: {
        isFinance() {
            if (this.$keycloak) {
                return this.$keycloak.hasResourceRole('finance-staff')
            } else {
                return false;
            }
        }
    },
    methods: {
        loadApplication() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/${this.$route.params.id}`)
                .then(response => {
                    this.application = response.data
                    this.isLoading = false
                })
        },
    }
}
</script>
<style>
</style>